import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LeaveComponent } from './leave.component';
import { ApplyComponent } from './components/apply/apply.component';
import { AssignLeaveComponent } from './components/assign-leave/assign-leave.component';
import { LeavePeriodComponent } from './components/leave-period/leave-period.component';


//Routing
import { mainRouting } from '../main.routes';
import { LeaveTypesComponent } from './components/leave-types/leave-types.component';
import { MyLeaveComponent } from './components/my-leave/my-leave.component';
import { AddEntitlementComponent } from './components/add-entitlement/add-entitlement.component';
import { WorkWeekComponent } from './components/work-week/work-week.component';
import { LeaveListComponent } from './components/leave-list/leave-list.component';
import { EmployeeEntitlementsComponent } from './components/employee-entitlements/employee-entitlements.component';
import { HolidaysComponent } from './components/holidays/holidays.component';
import { MyEntitlementsComponent } from './components/my-entitlements/my-entitlements.component';
import { AddHolidayComponent } from './components/add-holiday/add-holiday.component';
import { AddLeaveTypeComponent } from './components/add-leave-type/add-leave-type.component';
import {LeaveBalanceDetailsModule} from "./components/leave-balance-details/leave-balance-details.module";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LeaveBalanceDetailsModule,
    
    mainRouting
  ],
  declarations: 
  [
    LeaveComponent,
    ApplyComponent,
    MyLeaveComponent,
    AddEntitlementComponent,
    WorkWeekComponent,
    LeaveTypesComponent,
    AssignLeaveComponent,
    LeavePeriodComponent,
    LeaveListComponent,
    EmployeeEntitlementsComponent,
    HolidaysComponent,
    MyEntitlementsComponent,
    AddHolidayComponent,
    AddLeaveTypeComponent

  ]
})
export class LeaveModule { }



// WEBPACK FOOTER //
// ./src/app/modules/leave/leave.module.ts